import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProformaProjectFormsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proforma-project-forms',
	path: '/jira/servicedesk/projects/:projectKey/settings/forms',
	exact: true,
};
